import React, { useState } from 'react';
import { 
  Bell, Clock, Calendar, X, Plus, Trash2, 
  CheckCircle2, Circle, BellRing, ListCheck 
} from 'lucide-react';

const RemindersPage = ({ tasks, setTasks }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const today = new Date().toISOString().split('T')[0];
  const currentTime = new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

  // Form State
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [date, setDate] = useState(today);
  const [time, setTime] = useState(currentTime);

  const addReminder = () => {
    if (!title.trim()) return;
    const newReminder = {
      id: Date.now(),
      text: title,
      content: content,
      date: date,
      time: time,
      completed: false,
      alarmFired: false
    };
    setTasks([newReminder, ...tasks]);
    setTitle(''); setContent(''); setDate(today); setTime(currentTime);
    setIsModalOpen(false);
  };

  const toggleStatus = (id) => {
    setTasks(tasks.map(t => t.id === id ? { ...t, completed: !t.completed } : t));
  };

  // Filter Logic: Only show items that have a time set (Reminders)
  const now = new Date();
  const reminderTasks = tasks.filter(t => t.time);
  
  const pending = reminderTasks.filter(t => !t.completed).map(t => ({
    ...t,
    isMissed: new Date(`${t.date}T${t.time}`) < now
  }));
  
  const completed = reminderTasks.filter(t => t.completed);

  return (
    <div className="page-fade">
      <header className="header-flex">
        <h1 className="title">Alarms</h1>
        <button className="action-circle primary-bg" onClick={() => setIsModalOpen(true)}>
          <Plus size={22} />
        </button>
      </header>

      <div className="reminders-content">
        {/* --- ACTIVE SECTION --- */}
        <section className="reminder-group">
          <h3 className="section-label">Active Alarms</h3>
          {pending.length > 0 ? (
            pending.map(t => (
              <AlarmItem key={t.id} t={t} onToggle={toggleStatus} onDelete={(id) => setTasks(tasks.filter(x => x.id !== id))} />
            ))
          ) : (
            <div className="empty-mini">No active reminders</div>
          )}
        </section>

        {/* --- COMPLETED SECTION --- */}
        {completed.length > 0 && (
          <section className="reminder-group finished-section">
            <h3 className="section-label completed-label">
              <ListCheck size={14} /> Finished
            </h3>
            {completed.map(t => (
              <AlarmItem key={t.id} t={t} onToggle={toggleStatus} onDelete={(id) => setTasks(tasks.filter(x => x.id !== id))} />
            ))}
          </section>
        )}
      </div>

      {/* --- Create Modal --- */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="glass-modal animate-slide-up">
            <div className="modal-header">
              <h3>Set New Alert</h3>
              <X onClick={() => setIsModalOpen(false)} className="cursor-p" />
            </div>
            <input className="modal-input" placeholder="Alarm Title" value={title} onChange={e => setTitle(e.target.value)} />
            <textarea className="modal-input textarea" placeholder="Alarm Details..." value={content} onChange={e => setContent(e.target.value)} />
            <div className="picker-grid">
              <div className="field">
                <label>Date</label>
                <input type="date" value={date} onChange={e => setDate(e.target.value)} />
              </div>
              <div className="field">
                <label>Time</label>
                <input type="time" value={time} onChange={e => setTime(e.target.value)} />
              </div>
            </div>
            <button className="confirm-btn" onClick={addReminder}>Activate Alarm</button>
          </div>
        </div>
      )}
    </div>
  );
};

// Sub-component for clean rendering
const AlarmItem = ({ t, onToggle, onDelete }) => (
  <div className={`alarm-card ${t.isMissed && !t.completed ? 'overdue' : ''} ${t.completed ? 'done-style' : ''}`}>
    <div className="alarm-main">
      <div className="checkbox-hit" onClick={() => onToggle(t.id)}>
        {t.completed ? <CheckCircle2 color="#10b981" /> : <Circle color="#94a3b8" />}
      </div>
      <div className="alarm-info">
        <h4 className={t.completed ? 'strike-text' : ''}>{t.text}</h4>
        {t.content && <p className="alarm-content-text">{t.content}</p>}
        <div className="alarm-meta-row">
          <Clock size={12} /> <span>{t.time}</span>
          <Calendar size={12} style={{marginLeft: '8px'}} /> <span>{t.date}</span>
        </div>
      </div>
    </div>
    <button className="icon-del-btn" onClick={() => onDelete(t.id)}>
      <Trash2 size={18} />
    </button>
  </div>
);

export default RemindersPage;